/**
 * AI-generated code, moderated by Lukasz Zygmanski
 */
import type {RouteObject} from 'react-router-dom';

export const routes = [
  {
    path: 'releases',
    async lazy() {
      const {ReleasesPage} = await import('./pages/ReleasesPage');
      return {element: <ReleasesPage />};
    },
  },
] as RouteObject[];
